import { Component, OnInit } from '@angular/core';
import { ApiPartnerService } from '../../api/api-partner.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, NgForm, ValidatorFn, EmailValidator, Validators } from '@angular/forms';
import { URLSearchParams } from '@angular/http';
import swal from 'sweetalert/dist/sweetalert.min.js';

@Component({
  selector: 'app-playbox',
  templateUrl: './playbox.component.html',
  styleUrls: ['./playbox.component.css']
})
export class PlayboxComponent implements OnInit {

 


  alert_failed = false
  alert_success = false


  formNew = this.fb.group({
    sn: [''],
    customerid: [''],
    nama: [''],
    tlp: [''],
    email: [''],
    pin: [''],
    confirm: [''],
  })

  alert_act: any = [];

  successreg : string;
  errorreg : string;
  message : string;

  snvalid = false
  snisnotvalid = false
  generate1 = false
  reset1 = false
  onload = false
  reff = false
  offbtn = false
  confirmation = false
  confirmdiv = false
  turnoffdiv = false
  
  count = 30

  constructor(
    public partnerService: ApiPartnerService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router
  ) { }

  ngOnInit() {
    this.loadStart()
  }
  
  loadStart() {
    this.formNew.get('sn').enable()
    this.formNew.get('confirm').enable()
    this.clearall()
  }
  
  clearall(){
    this.formNew.reset()
    this.snisnotvalid = false
    this.confirmation = false
    this.confirmdiv = false
    this.turnoffdiv = false
    this.snvalid = false
    this.offbtn = false
    this.reset1 = false
    this.reff = false
  }
  refreshPage() {
    this.ngOnInit()
  }

  onActionclick(act:any, item: any){
    this.alert_act = act
    if(this.alert_act == 'reset1'){
      this.formNew.get('confirm').setValue("")
      this.formNew.get('confirm').enable()
      this.turnoffdiv = false
      this.confirmdiv = true
      this.reset1 = true

    }
    if(this.alert_act == 'reset2'){
      // this.reset1 = false
      this.resetpin()
    }
    if(this.alert_act == 'turnoff1'){
      this.formNew.get('confirm').setValue("")
      this.formNew.get('pin').setValue("")
      this.turnoffdiv = true
      this.confirmdiv = true
      this.reset1 = false
    }
    if(this.alert_act == 'turnoff2'){
      this.turnoff()
    }
  }

  isconfirm() {
    if (this.formNew.get('confirm').value == "CONFIRM") {
      this.confirmation=true
    }else{
      this.confirmation=false
    }
  }

  generatenew(){
    this.count = 30
    this.countdown()

    let ranstring:any = Math.floor(100000 + Math.random() * 900000);   
    ranstring = String(ranstring);
    ranstring = ranstring.substring(0,4);
    // console.log(ranstring)
    this.formNew.get('pin').setValue(ranstring);

  }

  countdown(){
    if(this.count == 0){
      this.generate1 = false
    }else{
      this.generate1 = true
      // console.log(this.count)
      setTimeout(()=>{
        this.count -=1
        this.countdown()
      }, 1000);
    }
  }
  
  checksncust(){
    const data = {
      "sn": this.formNew.get('sn').value
    }
    // console.log(data)

    if(this.formNew.get('sn').value != ""){

      return this.partnerService.Checksncust(data).subscribe((output: any) => {
        // console.log(output.data)
        if(output.data){

          this.formNew.get('customerid').setValue(output.data.id);
          this.formNew.get('nama').setValue(output.data.nama);
          this.formNew.get('tlp').setValue(output.data.tlp);
          this.formNew.get('email').setValue(output.data.email);

          if(output.status){
  
            this.snisnotvalid = false
            this.snvalid = true
          }else{
    
            this.message = output.message
            this.snisnotvalid = true
            this.snvalid = false
            this.reset1 = false
          }
        }else{
          this.formNew.get('customerid').setValue("");
          this.formNew.get('nama').setValue("");
          this.formNew.get('tlp').setValue("");
          this.formNew.get('email').setValue("");
          this.formNew.get('pin').setValue("");
          
          this.message = output.message
          this.snisnotvalid = true
          this.snvalid = false
          this.reset1 = false
        }
        
      })
    }else{
      this.formNew.get('customerid').setValue("");
      this.formNew.get('nama').setValue("");
      this.formNew.get('tlp').setValue("");
      this.formNew.get('email').setValue("");
      this.formNew.get('pin').setValue("");
      this.snisnotvalid = false
      this.snvalid = false
      this.reset1 = false
    }
  }

  resetpin(){
    this.onload = true
    this.reff = true
    this.offbtn = true
    return this.partnerService.Resetpin(this.formNew.value).subscribe((output:any)=>{
      this.formNew.get('sn').disable()
      this.formNew.get('confirm').disable()
      console.log(output)
      if(output.status){
        this.onload = false
        this.reff = false
        
        this.message = output.message
        this.alertsx(this.message)
        // this.alert_success = true
        // setTimeout(()=>{
        //   this.alert_success = false
        // }, 10000);
      }else{

        this.message = output.message
        this.alertfx(this.message)
        // this.alert_failed = true
        // setTimeout(()=>{
        //   this.alert_failed = false
        // }, 10000);
      }
    })
  }

  turnoff(){
    this.onload = true
    this.reff = true
    this.offbtn = true
    return this.partnerService.Turnoffpin(this.formNew.value).subscribe((output:any)=>{
      this.formNew.get('sn').disable()
      this.formNew.get('confirm').disable()
      console.log(output)
      if(output.status){
        this.onload = false
        this.reff = false
        
        this.message = output.message
        this.alertsx(this.message)

      }else{

        this.message = output.message
        this.alertfx(this.message)
      }
    })
  }

  alertsx(item:any){

    swal({
      title: "Sukses!",
      text: item,
      icon: "success",
      button: "OK",
    });
  }
  alertfx(item:any){

    swal({
      title: "Gagal!",
      text: item,
      icon: "error",
      button: "OK",
    });
  }

  
  

}
